import { render, staticRenderFns } from "./LandingNoListNL.vue?vue&type=template&id=18cd4cb4&scoped=true"
import script from "./LandingNoListNL.vue?vue&type=script&lang=js"
export * from "./LandingNoListNL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cd4cb4",
  null
  
)

export default component.exports